module.exports = __webpack_public_path__ + "static/media/edgecumbe-bg.02adf8d1.jpeg";